import React from 'react';
import { graphql } from 'gatsby';
import { LazyLoadComponent } from 'react-lazy-load-image-component';

import SEO from '@common/SEO';
import Main from '@common/Main';
import Blocks from '@common/Blocks';
import FadeIn from '@common/FadeIn';

export const query = graphql`
  query($slug: String!) {
    contentfulPage(slug: { eq: $slug }) {
      ...PageFragment
    }
  }
`

const Page = ({ data }) => {
  const { mainContent } = data?.contentfulPage;
  return (
    <Main>
      {mainContent && mainContent.map((content, index) => (
        <LazyLoadComponent key={index} visibleByDefault={index <= 1 || !content.showFadeIn}>
          <FadeIn showFade={content.showFadeIn || content.showFadeIn == null}>
            {/* Setting the view height prevents the animation from triggering before the content loads */}
            <Blocks data={content} style={{height: '100vh'}}/>
          </FadeIn>
        </LazyLoadComponent>
      ))}
    </Main>
  )
}

export default Page

export const Head = ({ location, data }) => {
  const {
    titleTag,
    index,
    metaDescription,
    metaImage,
    schema
  } = data?.contentfulPage;
  return (
    <SEO
      index={index}
      titleTag={titleTag}
      metaDescription={metaDescription}
      metaImageUrl={metaImage?.url}
      metaImageWidth={metaImage?.width}
      metaImageHeight={metaImage?.height}
      schema={schema}
      location={location}
    />
  )
}
